import { API_SOURCE } from "../../../constants/app-constants";
import { DRIVA_POLLING_STATUS } from "../../../constants/checkout-constants";
import { CONFIG_BODY } from "../../../constants/optimize-constants";
// import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { B2cFinanceService, BffDataAU, CheckoutDrivaService, ConfigService } from "../../../service";
import { getLoanOfferDetailsSuccess } from "../checkout-info/actions";
import Types from "./types";

const getDrivaTimeoutConfigRequest = (loading) => ({
    type: Types.GET_DRIVA_TIMEOUT_CONFIG_REQUEST,
    loading
});

const getDrivaTimeoutConfigSuccess = (data) => ({
    type: Types.GET_DRIVA_TIMEOUT_CONFIG_SUCCESS,
    data
});

const getDrivaTimeoutConfigFailure = (error) => ({
    type: Types.GET_DRIVA_TIMEOUT_CONFIG_FAILURE,
    error
});

const getInHouseFinanceTimeoutConfigRequest = (loading) => ({
    type: Types.GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_REQUEST,
    loading
});

const getInHouseFinanceTimeoutConfigSuccess = (data) => ({
    type: Types.GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_SUCCESS,
    data
});

const getInHouseFinanceTimeoutConfigFailure = (error) => ({
    type: Types.GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_FAILURE,
    error
});

const getDrivaTimeoutConfig = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(getDrivaTimeoutConfigRequest(true));
        ConfigService.fetchDrivaConfigDetails({type: "TIME_OUT_CONFIG", key: "DRIVA_POLLING"}).then(response => {
            dispatch(getDrivaTimeoutConfigSuccess(response.data && response.data.data && response.data.data[0]));
            resolve(response.data && response.data.data && response.data.data[0]);
        }).catch(error => {
            dispatch(getDrivaTimeoutConfigFailure(error));
            reject(error);
        });
    });
};

const getInHouseFinanceTimeoutConfig = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(getInHouseFinanceTimeoutConfigRequest(true));
        ConfigService.fetchDrivaConfigDetails({type: "TIME_OUT_CONFIG", key: "INHOUSE_POLLING"}).then(response => {
            dispatch(getInHouseFinanceTimeoutConfigSuccess(response.data && response.data.data && response.data.data[0]));
            resolve(response.data && response.data.data && response.data.data[0]);
        }).catch(error => {
            dispatch(getInHouseFinanceTimeoutConfigFailure(error));
            reject(error);
        });
    });
};

const drivaPollApiSuccess = (data) => ({
    type: Types.DRIVA_API_POLL_SUCCESS,
    data
});

const drivaPollApiFailure = (error) => ({
    type: Types.DRIVA_API_POLL_FAILURE,
    error
});

const inHouseFinancePollApiSuccess = (data) => ({
    type: Types.IN_HOUSE_FINANCE_API_POLL_SUCCESS,
    data
});

const inHouseFinancePollApiFailure = (error) => ({
    type: Types.IN_HOUSE_FINANCE_API_POLL_FAILURE,
    error
});

const drivaPollApi = (params = {}) =>  (dispatch, getState) => {
    const { user: { secureToken } } = getState();
    return new Promise((resolve, reject) => {
        CheckoutDrivaService.drivaPollingApi(params, secureToken).then(response => {
            dispatch(drivaPollApiSuccess(response.data));
            resolve(response.data);
        }).catch(error => {
            dispatch(drivaPollApiFailure(error));
            reject(error);
        });
    });
};

const inHouseFinancePollApi = (params = {}) => (dispatch, getState) => {
    const {
        user: { secureToken }
        // abExperiment: {
        //     showLoanOfferScreen
        // }
    } = getState();
    // const experiment = (showLoanOfferScreen || {}).data === EXPERIMENT_TYPE.VARIANT_B ? "WHITE_LABEL" : "LOAN_COMPARISON";
    // const apiParams = {
    //     experiment
    // };
    return new Promise((resolve, reject) => {
        B2cFinanceService.inHouseFinancePollingApi(params.orderId, secureToken).then(response => {
            dispatch(inHouseFinancePollApiSuccess(response.data));
            const { pollStatus } = response.data || {};
            if (pollStatus === DRIVA_POLLING_STATUS.COMPLETED) {
                dispatch(getLoanOfferDetailsSuccess(response.data, true));
            }
            resolve(response.data);
        }).catch(error => {
            dispatch(inHouseFinancePollApiFailure(error));
            reject(error);
        });
    });
};

const inHouseFinanceFirstFinancePollApi = (params = {}) => (dispatch, getState) => {
    const {
        user: { secureToken },
        preApprovalLoan: {
            financeUniqueId
        }
    } = getState();
    const token = params.token || secureToken;
    const financeUuid = params.uuid || financeUniqueId;
    return new Promise((resolve, reject) => {
        B2cFinanceService.inHouseFinanceFirstFinancePollApi(financeUuid, token).then(response => {
            dispatch(inHouseFinancePollApiSuccess(response.data));
            resolve(response.data);
        }).catch(error => {
            dispatch(inHouseFinancePollApiFailure(error));
            reject(error);
        });
    });
};

const requestCallbackSuccess = (data) => ({
    type: Types.DRIVA_API_CALLBACK_SUCCESS,
    data
});

const requestCallbackFailure = (error) => ({
    type: Types.DRIVA_API_CALLBACK_FAILURE,
    error
});

const requestCallback = (params = {}) => (dispatch, getState) => {
    const { user: { secureToken, email }} = getState();
    const payload = {...params, userId: email};
    return new Promise((resolve, reject) => {
        CheckoutDrivaService.drivaCallbackApi(payload, secureToken).then(response => {
            dispatch(requestCallbackSuccess(response.data));
            resolve(response.data);
        }).catch(error => {
            dispatch(requestCallbackFailure(error));
            reject(error);
        });
    });
};

const getLoanAppToggleConfigRequest = (loading) => ({
    type: Types.LOAN_APP_TOGGLE_CONFIG_REQUEST,
    loading
});

const getLoanAppToggleConfigSuccess = (data) => ({
    type: Types.LOAN_APP_TOGGLE_CONFIG_SUCCESS,
    data
});

const getLoanAppToggleConfigFailure = (error) => ({
    type: Types.LOAN_APP_TOGGLE_CONFIG_FAILURE,
    error
});

const getCheckoutScreenConfigSucess = (data) => ({
    type: Types.CHECKOUT_SCREEN_CONFIG_SUCCESS,
    data
});

const getCheckoutScreenConfigFailure = (error) => ({
    type: Types.CHECKOUT_SCREEN_CONFIG_FAILURE,
    error
});

const getCheckoutScreenConfigRequest = (loading) => ({
    type: Types.CHECKOUT_SCREEN_CONFIG_REQUEST,
    loading
});

const getLoanAppToggleConfig = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(getLoanAppToggleConfigRequest(true));

        ConfigService.fetchConfigDetails({payload: [{...CONFIG_BODY.LOAN_APP_TOGGLE_CONFIG}], source: API_SOURCE.M_SITE}).then(response => {
            dispatch(getLoanAppToggleConfigSuccess(response.data && response.data.data && response.data.data[0]));
            resolve(response.data && response.data.data && response.data.data[0]);
        }).catch(error => {
            dispatch(getLoanAppToggleConfigFailure(error));
            reject(error);
        });
    });
};

const getCheckoutScreenConfig = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(getCheckoutScreenConfigRequest(true));
        ConfigService.fetchConfigDetails({payload: [{...CONFIG_BODY.CHECKOUT_SCREEN_CONFIG, key: API_SOURCE.WEB_APP}], source: API_SOURCE.WEB_APP}).then(response => {
            dispatch(getCheckoutScreenConfigSucess(response.data && response.data.data && response.data.data[0]));
            resolve(response.data && response.data.data && response.data.data[0]);
        }).catch(error => {
            dispatch(getCheckoutScreenConfigFailure(error));
            reject(error);
        });
    });
};

const fetchConfigInit = () => ({
    type: Types.FETCH_CONFIG_INIT
});

const fetchConfigSuccess = (data, params) => ({
    type: Types.FETCH_CONFIG_SUCCESS,
    data,
    params
});

const fetchConfigFailure = (error) => ({
    type: Types.FETCH_CONFIG_FAILURE,
    error
});

const fetchBodyTypeConfigInit  = () => ({
    type: Types.FETCH_BODY_TYPE_CONFIG_INIT
});

const fetchBodyTypeConfigSuccess = (data, params) => ({
    type: Types.FETCH_BODY_TYPE_CONFIG_SUCCESS,
    data,
    params
});

const fetchBodyTypeConfigFailure = (error) => ({
    type: Types.FETCH_BODY_TYPE_CONFIG_FAILURE,
    error
});

const fetchBodyTypeConfig = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(fetchBodyTypeConfigInit());
        ConfigService.fetchConfigDetails({payload: [{...CONFIG_BODY.BODY_TYPE_CONFIG}], source: API_SOURCE.M_SITE}).then(response => {
            dispatch(fetchBodyTypeConfigSuccess(response.data && response.data.data && response.data.data[0]));
            resolve(response.data && response.data.data && response.data.data[0]);
        }).catch(error => {
            dispatch(fetchBodyTypeConfigFailure(error));
            reject(error);
        });
    });
};

const fetchConfigWithTypeSuccess = (data) => ({
    type: Types.FETCH_CONFIG_WITH_TYPE_SUCCESS,
    data
});

const fetchConfigWithTypeFailure = (error) => ({
    type: Types.FETCH_CONFIG_WITH_TYPE_FAILURE,
    error
});

const fetchConfigWithTypeRequest = (loading) => ({
    type: Types.FETCH_CONFIG_WITH_TYPE_INIT,
    loading
});

const fetchConfigWithType = (payload) => (dispatch) => {

    return new Promise((resolve, reject) => {
        dispatch(fetchConfigWithTypeRequest(true));
        ConfigService.fetchConfigDetails({payload}).then(response => {
            dispatch(fetchConfigWithTypeSuccess(response.data));
            resolve(response.data);
        }).catch(error => {
            dispatch(fetchConfigWithTypeFailure(error));
            reject(error);
        });
    });
};

const fetchTestDriveCmsConfigInit = () => ({
    type: Types.FETCH_TEST_DRIVE_CMS_CONFIG_INIT
});

const fetchTestDriveCmsConfigSuccess = (data) => ({
    type: Types.FETCH_TEST_DRIVE_CMS_CONFIG_SUCCESS,
    data
});

const fetchTestDriveCmsConfigFailure = (error) => ({
    type: Types.FETCH_TEST_DRIVE_CMS_CONFIG_FAILURE,
    error
});

const fetchTestDriveCmsConfig = (params = {}) => async (dispatch) => {
    dispatch(fetchTestDriveCmsConfigInit());
    try {
        const response = await BffDataAU.getCmsContent(params);
        dispatch(fetchTestDriveCmsConfigSuccess(response.data));
        return response.data;
    } catch (error) {
        dispatch(fetchTestDriveCmsConfigFailure(error));
        throw error;
    }
};
const fetchCheckinWorkflowInit = () => ({
    type: Types.FETCH_CHECKIN_WORKFLOW_INIT
});

const fetchCheckinWorkflowSuccess = (data) => ({
    type: Types.FETCH_CHECKIN_WORKFLOW_SUCCESS,
    data
});

const fetchCheckinWorkflowFailure = (error) => ({
    type: Types.FETCH_CHECKIN_WORKFLOW_FAILURE,
    error
});

const fetchCheckinWorkflow = () => (dispatch) => {
    dispatch(fetchCheckinWorkflowInit());
    return new Promise((resolve, reject) => {
        ConfigService.fetchConfigDetails({payload: [{...CONFIG_BODY.CHECKIN_WORKFLOW}]}).then(response => {
            dispatch(fetchCheckinWorkflowSuccess(response.data));
            resolve(response.data);
        }).catch(error => {
            dispatch(fetchCheckinWorkflowFailure(error));
            reject(error);
        });
    });
};

export {
    getDrivaTimeoutConfig,
    drivaPollApi,
    requestCallback,
    getInHouseFinanceTimeoutConfig,
    inHouseFinancePollApi,
    inHouseFinanceFirstFinancePollApi,
    fetchConfigInit,
    fetchConfigSuccess,
    fetchConfigFailure,
    fetchBodyTypeConfig,
    getLoanAppToggleConfig,
    fetchConfigWithType,
    getCheckoutScreenConfig,
    fetchTestDriveCmsConfig,
    fetchCheckinWorkflow
};
